import React from "react";
/* eslint-disable */
import {
  Box, TableBody, TableCell, TableContainer, TableHead, TableRow, Table
} from '@material-ui/core';


export default class ComponentToPrint extends React.Component {

  render() {
    const tableData = this.props.tableData;
    const searchData = this.props.searchData;

    return (
      <div>
        <h3><center><u>Product Approved Prices</u></center></h3>
        <h4><center>{searchData.groupID} - {searchData.operationEntityID}</center></h4>
        <h4><center>{searchData.productCategoryID} - {searchData.cropID}</center></h4>
        <h4><center>{searchData.date}</center></h4>
        <div>&nbsp;</div>
        <h4><center></center></h4>
        <div>&nbsp;</div>
        <Box minWidth={1050}>
          <TableContainer style={{ marginLeft: '5px' }}>
            <Table aria-label="caption table">
              <TableHead>
                <TableRow>
                  <TableCell align={'left'}>Crop Name</TableCell>
                  <TableCell align={'left'}>Collection Center</TableCell>
                  <TableCell align={'left'}>Quantity(KG)</TableCell>
                  <TableCell align={'left'}>Status</TableCell>
                  <TableCell align={'left'}>PP(LKR)</TableCell>
                  <TableCell align={'left'}>AP(LKR)</TableCell>
                  <TableCell align={'left'}>Reorder Price(LKR)</TableCell>
                  <TableCell align={'left'}>RP(LKR)</TableCell>
                  <TableCell align={'left'}>Realized Price Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tableData.map((data, index) => (
                  <>
                    {data.dataList.map((item, itemIndex) => (
                      <TableRow key={itemIndex}>
                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                          {data.productName}
                        </TableCell>
                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                          {item.operationEntity}
                        </TableCell>
                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                          {item.quantity.toFixed(2)}
                        </TableCell>
                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                          {item.status == 1 ? 'Pending' : item.status == 2 ? 'Pending' : item.status == 3 ? 'Approved' : item.status == 4 ? 'Rejected' : ''}
                        </TableCell>
                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                          {item.proposedPrice.toFixed(2)}
                        </TableCell>
                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                          {item.approvedPrice.toFixed(2)}
                        </TableCell>
                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                          {item.secondProposedPrice.toFixed(2)}
                        </TableCell>
                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                          {item.realizedPrice.toFixed(2)}
                        </TableCell>
                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                          {item.realizedPriceStatus == 0 ? 'Not Set' : item.realizedPriceStatus == 1 ? 'New' : item.realizedPriceStatus == 2 ? 'Pending' : item.realizedPriceStatus == 3 ? 'Approved' : item.realizedPriceStatus == 4 ? 'Rejected' : ''}
                        </TableCell>
                      </TableRow>
                    ))}
                  </>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <h4><center>----End of the list----</center></h4>
      </div>
    );
  }
}
